import React from 'react';
import cn from 'clsx';
import { BonusLogo } from '@fronton/icons-react/logos';
import { Typography } from '../../typography';
import {
  cashbackIcon,
  cashbackPlate,
  cashbackPlateImage,
  cashbackPlateImageSizeMap,
  cashbackPlateSizeMap,
  cashbackText,
  cashbackTextSmall,
} from './cashback-plate-styles';
import { CashbackPlateSize } from './cashback-plate-types';

type CashbackPlateProps = {
  cashback: number;
  className?: string;
  size: CashbackPlateSize;
}

export const CashbackPlate: React.FC<CashbackPlateProps> = ({ cashback, className, size }) => (
  <div className={cn(cashbackPlate, className, cashbackPlateSizeMap[size])}>
    <img
      className={cn(cashbackPlateImage, cashbackPlateImageSizeMap[size])}
      src="https://cdn.lemanapro.ru/lmru/image/upload/fudzi/elbrus/images/landings/common/discount/cashback-plate.png/cashback-plate.png" />
    <BonusLogo className={cashbackIcon} />
    <Typography className={cn(cashbackText, { [cashbackTextSmall]: size === 's' })} variant="overline" color="text-primary-invert">
      {cashback}%  БАЛЛАМИ
    </Typography>
  </div>
)
